import styled from 'styled-components'

export const IconWrapper = styled.div`
  position: absolute;
  right: 20px;
  top: calc(50% - 10px);
`
